
import AnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";

export default class AnticipateAnimateSymbolBehaviour extends AnimateSymbolBehaviour {

    public behaviourName: string = "AnticipateAnimate";

    /**
     * Same as AnimateBehaviour except for landing
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAnimation="win"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "win") {
        super(symbol, defaultAnimation);
    }

    public anticipate(): Contract<void> {
        return this.animate("_antic", ["antic"], false, true);
    }

    public highlight(): Contract<void> {
        this.static();
        return Contract.empty();
    }

    public win(): Contract<void> {
        this.static();
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        this.static();
        return Contract.empty();
    }
}
